"use client";

import React from "react";
import { Sparkles } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
function ServicesConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
        {[...Array(8)].map((_, i) => <div key={i} data-index={i} className="h-[300px] rounded-none bg-card/50 animate-pulse border border-border/50" />)}
      </div>;
  }
  if (error) {
    return <div className="mt-16 text-center text-muted-foreground">
        <p>Unable to load field services. Please contact our support team.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="mt-16 text-center text-muted-foreground">
        <p>No specialized services listed at this time.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
      {posts.map((post, i) => <Link key={post.id} to={post.link || "#"} className="block group h-full focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-none" data-index={i}>
          <Card className="h-full bg-card/40 backdrop-blur-md border-border/50 rounded-none transition-all duration-300 group-hover:border-primary group-hover:bg-card/80 group-hover:shadow-xl">
            <CardHeader className="pb-4">
              <div className="flex items-center justify-between mb-4">
                <span className="text-sm font-medium text-muted-foreground/70 font-mono">
                  REF.{String(i + 1).padStart(2, '0')}
                </span>
                <Sparkles className="w-6 h-6 text-primary stroke-[1.5] opacity-80 group-hover:opacity-100 transition-opacity" />
              </div>
              <CardTitle className="text-xl font-default text-foreground group-hover:text-primary transition-colors">
                {post.customFields?.wvc_service_titulo || post.title}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-base text-muted-foreground font-default leading-relaxed line-clamp-4">
                {post.customFields?.wvc_service_descricao || "Reliable low-voltage execution and technical field support for Kansas City contractors."}
              </CardDescription>
            </CardContent>
          </Card>
        </Link>)}
    </div>;
}
export default function Services() {
  const wp_query_params = {
    post_type: "service",
    per_page: 12,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}